import React, { useEffect, useState, useContext } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { viewAlbum, editAlbum, uploadToAlbum, deleteImageFromAlbum } from '../Network/Gallery'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { Container, Loading, TablePagination, HeaderTitle, ImagePreview } from '../Library'
import { baseURL } from '../Network/Config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { ModalContext } from '../Library/ModalContext'
import { setDocumentTitle } from '../AppTitle'
import dayjs from 'dayjs'
import "./Album.css"

function Album() {
    const { id } = useParams();
    const modal = useContext(ModalContext)
    const notify = useContext(NotifyContext)
    const [isLoading, setLoading] = useState(false);
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.gallery;
    const [title, setTitle] = useState('');
    const [createdDate, setCreatedDate] = useState('');
    const [updatedDate, setUpdatedDate] = useState('');
    const [albumName, setAlbumName] = useState('');
    const [description, setDescription] = useState('');
    const [images, setImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState('');
    const [isError, setError] = useState(false)

    // Content list album
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 9
    const totalPage = Math.ceil(images.length / perPage)
    const indexOfLast = currentPage * perPage
    const indexOfFirst = indexOfLast - perPage

    const fetchData = () => {
        setLoading(true)
        viewAlbum(id, 
            (data)=>{
                setDocumentTitle(data.albumName)
                setTitle(data.albumName)
                setCreatedDate(data.createdDate)
                setUpdatedDate(data.updatedDate)
                setAlbumName(data.albumName)
                setDescription(data.description)
                setImages(data.images)
                setLoading(false);
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false);
            })
    }

    const updateAlbum = () =>{
        if(!albumName || !description){
            setError(true)
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            return;
        }

        setLoading(true)
        editAlbum(id, albumName, description,
            ()=>{
                setError(false);
                notify.showNotify(lang.update_success, lang.update_success_desc, 0)
                fetchData()
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    const uploadImage = () =>{
        setLoading(true)
        uploadToAlbum(id, selectedImage,
            ()=>{
                setSelectedImage(null)
                notify.showNotify(lang.update_success, lang.update_success_desc, 0)
                fetchData()
            },
            (error)=>{
                setLoading(false)
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    const deleteImage = (imageId) =>{
        setLoading(true)
        deleteImageFromAlbum(imageId,
            ()=>{
                fetchData()
            },
            (error)=>{
                setLoading(false)
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    const convertDate = (toDate) => {
        let date = new Date(toDate)
        let formatted = dayjs(date).format("D MMMM YYYY - H:mm")
        return formatted
    }

    const previewImage = (key) =>{
        modal.setComponent(
            <ImagePreview
            initialKey={key}
            imagesSet={images}
            isGetBaseURL={true}
            />
        )
        modal.setHeader(lang.image)
        modal.setShowHeader(true)
        modal.setDark(true)
        modal.setShow(true)
    }

    useEffect(()=>{
        fetchData()
    },[])

    return (
        <Container topbarTitle={langCx.lang.sidebar.gallery}> 
        { isLoading ? <Loading/> : null }
        <div id="album">
            <HeaderTitle
            title={title}
            description={
                <div>
                    <div>{lang.create_date} : {convertDate(createdDate)}</div>
                    <div>{lang.update_date} : {convertDate(updatedDate)}</div>
                </div>
            }
            isShowBack
            backTo="/gallery"
            />
            <Row>
                <Col lg={6}>
                    <Form
                    style={{marginBottom: 20}}
                    onSubmit={(e)=>{
                        e.preventDefault();
                        updateAlbum();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.album_name}</Form.Label>
                            <Form.Control
                            value={albumName}
                            isInvalid={isError && !albumName}
                            onChange={(e)=>setAlbumName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.album_description}</Form.Label>
                            <Form.Control
                            as="textarea"
                            value={description}
                            isInvalid={isError & !description}
                            onChange={(e)=>setDescription(e.target.value)}
                            style={{height: 200}}
                            />
                        </Form.Group>
                        <hr/>
                        <Button
                        type="submit"
                        >
                            {lang.save_change}
                        </Button>
                    </Form>
                </Col>
                <Col lg={6}>
                    <div className="album-title">{lang.image}</div>
                    <Form className="upload-form"
                    onSubmit={(e)=>{
                        e.preventDefault()
                        uploadImage()
                    }}
                    >
                        <Form.File 
                        accept="image/*"
                        onChange={(e)=>{
                            let toUpload = e.target.files[0]
                            setSelectedImage(toUpload)
                            e.target.file = null
                        }}
                        required/>
                        <Button
                        type="submit"
                        variant="success"
                        >
                            {lang.upload}
                        </Button>
                    </Form>
                    <div className="image-container">
                        <Row>
                            { images.slice(indexOfFirst, indexOfLast).map((item, key) =>
                            <Col xs={4} key={key}>
                                <ImageItem
                                src={item.imagePath}
                                onClick={()=>previewImage(key)}
                                onDeleteClick={()=>{
                                    deleteImage(item.imageId)
                                }}
                                />
                            </Col>
                            )}
                            { images.length === 0 ?
                            <div className="no-image">
                                {lang.no_image}
                            </div>
                            : null
                            }
                        </Row>
                        
                    </div>
                    <div className="pagination">
                        <TablePagination
                        dataLength={totalPage}
                        size={10}
                        currentPage={currentPage}
                        handlerPaginationClick={(page)=>{ setCurrentPage(page) }}
                        nextClick={()=>{ setCurrentPage(currentPage + 1) }}
                        prevClick={()=>{ setCurrentPage(currentPage - 1) }}
                        firstPageClick={(first)=>{ setCurrentPage(first) }}
                        lastPageClick={(last)=>{ setCurrentPage(last) }}
                        disabledPrev={currentPage === indexOfFirst + 1}
                        disabledNext={currentPage === totalPage || images.length === 0}
                        />
                    </div>
                </Col>
            </Row>
        </div>
        </Container>
    )
}

function ImageItem(props){
    return(
        <>
        <div className="delete-btn"
            onClick={props.onDeleteClick}>
                <FontAwesomeIcon icon={faTrash}/>
        </div>
        <div className="image-item"
        onClick={props.onClick}>
            <img src={baseURL + props.src} alt={props.alt} className="thumbnail"/>
        </div>
        </>
    )
}

export default Album
